import { render, staticRenderFns } from "./SetupIntention.vue?vue&type=template&id=e02d7c7a&"
import script from "./SetupIntention.vue?vue&type=script&lang=js&"
export * from "./SetupIntention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports